import { NachrichtModel } from '../models/Nachrichten/NachrichtModel';
import { useQuery } from '@tanstack/react-query';
import { BehApiRoutes } from '../beh-api';

interface UseSubmissionsAsNachrichtenConfig {
  caseId?: string;
}

export function useSubmissionsAsNachrichten({
  caseId
}: UseSubmissionsAsNachrichtenConfig) {
  return useQuery<Array<NachrichtModel>>({
    queryKey: [BehApiRoutes.caseSubmissions(caseId ?? '')],
    enabled: !!caseId
  });
}
